
if(!__webpack_require__.federation){
    __webpack_require__.federation = {
        
chunkMatcher: function(chunkId) {
    return !/^(180|372|53|563)$/.test(chunkId);
},
rootOutputDir: "",

    };
}
